import { AppIcons } from "../assets/images";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import { InterstitialAd, TestIds } from "react-native-google-mobile-ads";
import messaging from "@react-native-firebase/messaging";
import DeviceInfo from "react-native-device-info";
import { createNavigationContainerRef } from "@react-navigation/native";
import axios from "axios";

export const androidInterstitialAdKey = __DEV__
  ? TestIds.INTERSTITIAL
  : "ca-app-pub-9904818286175982/7381139994";

export const androidBannerAdKey = __DEV__
  ? TestIds.BANNER
  : "ca-app-pub-9904818286175982/8885793355";

export const androidRewardsAdKey = __DEV__
  ? TestIds.REWARDED
  : "ca-app-pub-9904818286175982/5876486636";

export const androidAppOpenADKey = __DEV__
  ? TestIds.APP_OPEN
  : "ca-app-pub-9904818286175982/3616608113";

export const iosInterstitialAdKey = __DEV__
  ? TestIds.INTERSTITIAL
  : "ca-app-pub-9904818286175982/3988689894";

export const iosBannerAdKey = __DEV__
  ? TestIds.BANNER
  : "ca-app-pub-9904818286175982/8019148832";

export const iosRewardsAdKey = __DEV__
  ? TestIds.REWARDED
  : "ca-app-pub-9904818286175982/2675608229";

export const iosAppOpenADKey = __DEV__
  ? TestIds.APP_OPEN
  : "ca-app-pub-9904818286175982/7364281434";

export const interstitialAdKey =
  Platform.OS == "android" ? androidInterstitialAdKey : iosInterstitialAdKey;

export const bannerAdKey =
  Platform.OS == "android" ? androidBannerAdKey : iosBannerAdKey;

export const rewardAdKey =
  Platform.OS == "android" ? androidRewardsAdKey : iosRewardsAdKey;

export const interstitial = InterstitialAd.createForAdRequest(
  interstitialAdKey,
  {
    keywords: ["fashion", "clothing"],
  },
);

// DEV
// export const BASE_URL = "https://ludo-backend.nslinfotech.com";

// PRODUCTION / DEV
export const BASE_URL = "https://ludovoice-api.netscapelabs.com";

export const DEEP_LINK = "https://share.ludovoice.com/";
export const PRIVACY_POLICY = "https://www.ludovoice.com/privacy_policy.html";
export const TERMS_WITH_CONDITIONS =
  "https://www.ludovoice.com/term_and_condition.html";
export const SOCKET_URL = `${BASE_URL}/socket`;
export const SOCIAL_LOGIN = `${BASE_URL}/api/v1/auth/social-login`;
export const LOGOUT = `${BASE_URL}/api/v1/auth/logout`;
export const GET_USER_DETAIL = `${BASE_URL}/api/v1/user/getProfile`;
export const UPDATE_USER_PROFILE = `${BASE_URL}/api/v1/user/updateProfile`;
export const UPLOAD_PHOTO = `${BASE_URL}/api/v1/user/updateProfilePicture`;
export const GAME_CONFIG = `${BASE_URL}/api/v1/game/config`;
export const LUCKY_SPIN = `${BASE_URL}/api/v1/game/lucky-spin`;
export const UPDATE_APP_VERSION = `${BASE_URL}/api/v1/user/updateAppVersion`;
export const DELETE_ACCOUNT_REUQUST = `${BASE_URL}/api/v1/user/delete-request`;
export const DELETE_ACCOUNT_OTP = `${BASE_URL}/api/v1/user/delete-confirm`;
export const UPDATE_USER_STATUS = `${BASE_URL}/api/v1/user/presence`;

export const androidSkus = [
  "ludo_1000_coins",
  "ludo_10000_coins",
  "ludo_200000_coins",
  "ludo_25000_coins",
  "ludo_5000_coins",
  "ludo_75000_coins",
];

export const iosSkus = [
  // "ludo_1000_coins",
  "ludo_5000_coins",
  "ludo_10000_coins",
  "ludo_25000_coins",
  "ludo_75000_coins",
  "ludo_200000_coins",
];

export const getBool = async () => {
  try {
    const value = await AsyncStorage.getItem("@isSound");
    return value != null ? JSON.parse(value) : false;
  } catch (e) {
    console.log("Error reading boolean", e);
    return false;
  }
};

/**
 * method to get fcm
 * @author himanshu sharma
 * @returns
 */

export const getFCmToken = async () => {
  try {
    if (Platform.OS === "web") {
      const storage =
        typeof globalThis !== "undefined"
          ? (globalThis as any).localStorage
          : null;
      const stored = storage ? storage.getItem("web_device_token") : null;
      if (stored) return stored;
      const newToken =
        "web_fcm_" + Math.random().toString(36).substring(2, 12);
      if (storage) {
        storage.setItem("web_device_token", newToken);
      }
      return newToken;
    }
    // Register the device for remote messages
    if (!messaging().isDeviceRegisteredForRemoteMessages) {
      await messaging().registerDeviceForRemoteMessages();
    } else {
      const token = await messaging().getToken();
      if (token) {
        console.log("FCM Token:", token);
        return token;
      } else {
        const id = await DeviceInfo.getUniqueId();
        console.log("No FCM token received.");
        return id;
      }
    }
  } catch (error) {
    const id = await DeviceInfo.getUniqueId();
    console.error("Error getting FCM token:", error);
    return id;
  }
};

// export const getLocationFromIP = async () => {
//   const ip = await DeviceInfo.getIpAddress();

//   const response = await fetch(`https://ipapi.co/${ip}/json/`);
//   const data = await response.json();

//   console.log("Approx Location:", data.latitude, data.longitude,ip);
// };

// export const getApproxLocation = async () => {
//   try {
//     const ip = await DeviceInfo.getIpAddress();
//     // const response = await fetch(`http://ip-api.com/json/`);
//     const response = await fetch("https://ipapi.co/json/");
//     const data = await response.json();

//     console.log("API Response:", data);

//     const latitude = data.latitude;
//     const longitude = data.longitude;

//     console.log("Coords:", latitude, longitude, ip);
//     return { latitude, longitude };
//   } catch (error) {
//     console.log("ip Error:", error);
//     return null;
//   }
// };

export const getApproxLocation = async () => {
  try {
    const ip = await DeviceInfo.getIpAddress();
    // const response = await axios.get(`http://ip-api.com/json/`);
    const response = await axios.get("https://ipapi.co/json/");
    const data = response.data;

    console.log("API Response:", data);

    const latitude = data.latitude;
    const longitude = data.longitude;

    console.log("Coords:", latitude, longitude, ip);
    return { latitude, longitude };
  } catch (error) {
    console.log("ip Error:", error);
    return null;
  }
};

export const playerOptions = [
  {
    id: 1,
    players: 2,
    label: "2 players",
    icon: AppIcons.TwoPlayers,
  },
  {
    id: 2,
    players: 3,
    label: "3 players",
    icon: AppIcons.ThreePlayers,
  },
  {
    id: 3,
    players: 4,
    label: "4 players",
    icon: AppIcons.FourPlayers,
  },
];

export const piseList = [
  {
    id: 1,
    label: "Red",
    icon: AppIcons.RedToken,
  },
  {
    id: 2,
    label: "Blue",
    icon: AppIcons.BlueToken,
  },
  {
    id: 3,
    label: "Yellow",
    icon: AppIcons.YellowToken,
  },
  {
    id: 4,
    label: "Green",
    icon: AppIcons.GreenToken,
  },
];

export const playerCountList = [
  {
    id: 1,
    label: "2 Players",
    icon: AppIcons.TwoPlayers,
    numPlayers: 2,
  },
  {
    id: 2,
    label: "3 Players",
    icon: AppIcons.ThreePlayers,
    numPlayers: 3,
  },
  {
    id: 3,
    label: "4 Players",
    icon: AppIcons.FourPlayers,
    numPlayers: 4,
  },
];

/**
 * method to get params from an url
 * @param url - url to get the params
 * @returns
 */

export const getParams = (url: any): { session_id?: string; user?: string } => {
  const params = {};
  const queryString = url.split("?")[1] || "";
  // @ts-ignore
  queryString.split("&").forEach((part) => {
    const [key, value] = part.split("=");
    if (key) {
      // @ts-ignore
      params[decodeURIComponent(key)] = decodeURIComponent(value || "");
    }
  });
  return params;
};

/**
 * navigation container ref for navigating to the specific screen
 */
export const navRef = createNavigationContainerRef();

/**
 * method to truncate a text according to characters
 * @param text - content that need to be truncate
 * @param char - number of characters, upto which the text need to truncate
 * @returns
 */
export const truncateText = (text: string, char: number) => {
  if (text?.length > char) {
    return `${text?.substring(0, char)}...`;
  }
  return text;
};

export const objectIdToUUID = (objectId: string) => {
  // Ensure it's a valid 24-char hex string
  if (!/^[0-9a-fA-F]{24}$/.test(objectId)) {
    throw new Error("Invalid ObjectId");
  }

  // Format into UUID style (8-4-4-4-12)
  return (
    objectId.substring(0, 8) +
    "-" +
    objectId.substring(8, 12) +
    "-" +
    objectId.substring(12, 16) +
    "-" +
    objectId.substring(16, 20) +
    "-" +
    objectId.substring(20).padEnd(12, "0")
  ) // pad to 12 chars
    .toLowerCase();
};

export function formatCoins(value: number): string {
  if (value < 1000) return value.toString();

  const units: string[] = ["", "k", "M", "B", "T"];
  const unitIndex: number = Math.floor(Math.log10(value) / 3);
  const shortValue: string = (value / Math.pow(1000, unitIndex)).toFixed(1);

  // remove trailing .0
  return shortValue.replace(/\.0$/, "") + units[unitIndex];
}
